import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'

export const exportChargingCardPdfApi = (
  from: Date,
  to: Date,
  serialNo: string,
  cardId: string,
  authFetch: <T>(props: FetchProps) => Promise<T>
): Promise<string> => {
  const exportPdf = authFetch<string>({
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    path: `e-mobility/${serialNo}/charging/export/pdf?from=${from}&to=${to}&filter=authType=RFID,authData=${cardId}`,
    method: 'POST',
  })
  return exportPdf
}
